<template>
  <div class="app flex-row align-items-center load-animated">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form>
                  <h1>Clave de registro</h1>
                  <p class="text-muted">Ingresa la clave del producto</p>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-key"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      v-model="clave"
                      type="text"
                      class="form-control"
                      placeholder="Clave de registro"
                      autocomplete="current-key"
                    />
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      <b-button variant="primary" class="px-4" @click="validar()">Validar</b-button>
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <b-button
                        variant="link"
                        class="px-0 btn-link-help"
                        v-b-tooltip.hover
                        title="La clave del producto se encuentra en el reverso del empaque, consta de 16 dígitos"
                      >¿Necesitas ayuda?</b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { LicenciaService } from "@/services/licencia.service";

export default {
  name: "registro_clave",
  data: function() {
    return {
      clave: ""
    };
  },
  methods: {
    validar: function() {
      let mac = LicenciaService.getMacAddress();
      let data = {
        clave: this.clave,
        macAddress: mac
      };

      LicenciaService.validateMatchClave(data).then(resp => {
        Promise.resolve({ data: resp }).then(result => {
          if (result.data.notExist) {
            this.$swal({
              type: "warning",
              title: "¡ERROR!",
              text: "Clave de registo inválida",
              confirmButtonText: "Enterado"
            });
          } else {
            this.$swal({
              title: "¡BIENVENIDO",
              text: "Gracias por adquirir su clave de registro del CME",
              type: "success",
              showCancelButton: false,
              confirmButtonColor: "#3085d6",
              confirmButtonText: "¡Empezar ahora!"
            }).then((result) => {
                if(result.value){
                  this.$router.push('registro_usuario');
                }
            });
          }
        });
      });
    }
  }
};
</script>



